// Version : 0.0.1
// Author : VISHNU
// LastEdit : SATHISH VISHNU
//Last ADD : CHANGES FOR ADD UPDATE API TRUE FALSE CONTION'
// MODFIED DATA : 06-08-2025
/* eslint-disable @typescript-eslint/no-unused-vars */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';
import CompanyActionTypes from './company.type';
import {
	addAlterTableDetailsFailure,
	addAlterTableDetailsResponseChanged,
	addAlterTableDetailsSuccess,
	addCompanyDetailsFailure,
	addCompanyDetailsResponseChanged,
	addCompanyDetailsSuccess,
	addInstanceDetailsFailure,
	addInstanceDetailsResponseChanged,
	addInstanceDetailsSuccess,
	createCompanyFailure,
	createCompanyResponseChanged,
	createCompanySuccess,
	deleteCompanyDetailsFailure,
	deleteCompanyDetailsResponseChanged,
	deleteCompanyDetailsSuccess,
	deleteCompanyFailure,
	deleteCompanyResponseChanged,
	deleteCompanySuccess,
	fetchCompanyDetailsFailure,
	fetchCompanyDetailsResponseChanged,
	fetchCompanyDetailsSuccess,
	fetchExistDataFailure,
	fetchExistDataResponseChanged,
	fetchExistDataSuccess,
	getCompanyListFailure,
	getCompanyListResponseChanged,
	getCompanyListSuccess,
	updateCompanyDetailsFailure,
	updateCompanyDetailsResponseChanged,
	updateCompanyDetailsSuccess,
	updateCompanyFailure,
	updateCompanyResponseChanged,
	updateCompanySuccess,
} from './company.action';
import {
	AlterTableCreate,
	companyDetailsAdd,
	companyDetailsDelete,
	companyDetailsGet,
	companyDetailsUpdate,
	companyGetList,
	createCompany,
	deleteCompany,
	fetchExistData,
	instanceDetailsAdd,
	updateCompany,
} from './company.service';

/*************** Create Company Start ******************/
export function* addCompanyDetails({ payload }: any) {
	try {
		const {
			companyID,
			companyName,
			companyWebsite,
			companyAddress,
			companyPhoneNumber,
			companyEmailID,
			companyPincode,
			state,
			stateName,
			city,
			emergencyPhoneNumber,
			companyGstNumber,
			companyPayment,
			companyPanNumber,
			companyTinNumber,
			companyFax,
			userID,
			companyAlternateEmailID,
			companyAlternatePhoneNumber,
			companyAlternateFax,
			companyAuthority1,
			companyAuthority2,
			companyAuthority3,
			companyModal,
			isSMSAvailed,
			isPrePaid,
			NoOfSMSAlloted,
			smsSenderName,
			infogCompanyID,
			isThrift,
			singleCenterGroup,
			collectionPhotoNeeded,
			individualMemberSavings,
			groupSavings,
			groupLoan,
			maxRuralIncome,
			maxUrbanIncome,
			collectionLocationNeeded,
			nachCollection,
			morotiumUpdateNeeded,
			groupAccountNeeded,
			trainingNeededForLoanApproval,
			isIndividualLoan,
			isNomineeLoanApproval,
			goldLoanAvailed,
			needJournalEntryAfterEOD,
			provisionType,
			percentageOnSellingPrice,
			sponsorBankCode,
			utilityBankCode,
			primaryAccountHolder,
			checkAadharExist,
			checkMobileNoExist,
			isMonexoNeeded,
			isOfficerAttendanceNeeded,
			isWorkFlowManagementNeeded,
			isDailyEODNeeded,
			isDueReminderSMS,
			remindBeforeNoOfDays,
			isProductConfigNeed,
			isSubAccountNeeded,
			isPersonalLoanWithRangeProductNeeded,
			houseVerifyNeededNoOfDays,
			adminName,
			adminPhoneNumber,
			adminEmailID,
			adminPassword,
			adminPhoto,
			adminPaid,
			accountArr,
			databaseName,
			isSeperateInstance,
			onBoardingMember,
			isDuePaymentSMS,
			isForLeader,
			isForAllMember,
			PreviousSellingPrice,
			country,
			instanceName,
			newFinanceDB,
			newHrDB,
			loanAdvance,
			isDueRemSMSNeeded,
			paymentMethodTab,
			isPersonalLoanWithRangeProductNeededed,
			financeCompanyID,
		} = payload;
		const key = 'AddCompanyDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			CompanyName: companyName,
			CompanyWebsite: companyWebsite,
			CompanyAddress: companyAddress,
			CompanyPhoneNumber: companyPhoneNumber,
			CompanyEmail: companyEmailID,
			CompanyPinCode: companyPincode,
			CompanyCountry: 'India',
			CompanyState: state,
			CompanyStateName: stateName,
			CompanyCity: city,
			EmergencyPhoneNumber: emergencyPhoneNumber,
			CompanyGSTIN: companyGstNumber,
			CompanyPayment: companyPayment,
			CompanyPAN: companyPanNumber,
			CompanyTIN: companyTinNumber,
			CompanyFax: companyFax,
			CompanyCreatedBy: userID,
			CompanyAltEmail: companyAlternateEmailID,
			CompanyAltPhone: companyAlternatePhoneNumber,
			CompanyAltFax: companyAlternateFax,
			CompanyAuthority1: companyAuthority1,
			CompanyAuthority2: companyAuthority2,
			CompanyAuthority3: companyAuthority3,
			CompanyModal: companyModal,
			IsSMSAvailed: isSMSAvailed,
			IsPrepaid: isPrePaid,
			NoOfSMSAllowed: NoOfSMSAlloted,
			SMSSenderName: smsSenderName,
			InfogID: infogCompanyID,
			IsThrift: isThrift,
			IsSingleGroupCenter: singleCenterGroup,
			IsCollectionPhotoNeeded: collectionPhotoNeeded,
			IsIndividualSavings: individualMemberSavings,
			IsGroupSaving: groupSavings,
			IsGroupLoan: groupLoan,
			MaxRuralIncome: maxRuralIncome,
			MaxUrbanIncome: maxUrbanIncome,
			IsCollectionLocationNeeded: collectionLocationNeeded,
			IsNachCollectionNeeded: nachCollection,
			IsMorotiumUpdateNeeded: morotiumUpdateNeeded,
			IsGroupAccountNeeded: groupAccountNeeded,
			IsTrainingMandatoryForLoan: trainingNeededForLoanApproval,
			IsIndividualLoanNeeded: isIndividualLoan,
			IsNomineeLoanApproval: isNomineeLoanApproval,
			IsGoldLoanAvailed: goldLoanAvailed,
			NeedJournalEntryAfterEOD: needJournalEntryAfterEOD,
			ProvisionType: provisionType,
			PercentageOnSellingPrice: percentageOnSellingPrice,
			SponsorBankCode: sponsorBankCode,
			UtilityBankCode: utilityBankCode,
			PrimaryAccountHolder: primaryAccountHolder,
			CheckAadharExist: checkAadharExist,
			CheckMobileNoExist: checkMobileNoExist,
			IsMonexoNeeded: isMonexoNeeded,
			IsOfficerAttendanceNeeded: isOfficerAttendanceNeeded,
			IsWorkFlowManagementNeeded: isWorkFlowManagementNeeded,
			IsDailyEODNeeded: isDailyEODNeeded,
			IsDueReminderSMS: isDueRemSMSNeeded,
			RemindBeforeNoOfDays: remindBeforeNoOfDays,
			IsProductConfigNeed: isProductConfigNeed,
			IsSubAccountNeed: isSubAccountNeeded,
			IsPersonalLoanWithRangeProductNeeded: isPersonalLoanWithRangeProductNeeded,
			HouseVerifyNeededNoOfDays: houseVerifyNeededNoOfDays,
			AdminName: adminName,
			AdminPhoneNumber: adminPhoneNumber,
			AdminEmailID: adminEmailID,
			AdminPassword: adminPassword,
			AdminPhoto: adminPhoto,
			PreviousSellingPercentage: PreviousSellingPrice,
			AmountPaid: adminPaid,
			AccountArr: accountArr,
			InstanceName: instanceName,
			IsSeperateInstance: isSeperateInstance,
			IsonBoardingMemberSMS: onBoardingMember,
			IsDuePayment: isDuePaymentSMS,
			IsForLeader: isForLeader,
			IsForAllMember: isForAllMember,
			NewHrDB: newHrDB,
			NewFinanceDB: newFinanceDB,
			LoanAdvance: loanAdvance,
			PaymentMethodTab: paymentMethodTab,
			FinanceID: financeCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(companyDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addCompanyDetailsFailure(responseData.data));
		} else {
			yield put(addCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addCompanyDetailsFailure(error));
	}
}

export function* resetAddCompanyDetailsResponse() {
	yield put(addCompanyDetailsResponseChanged());
}

export function* onAddCompanyDetails() {
	yield takeLatest(CompanyActionTypes.ADD_COMPANY_DETAILS_START, addCompanyDetails);
}

export function* onAddCompanyDetailsResponseReset() {
	yield takeLatest(
		CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_RESET,
		resetAddCompanyDetailsResponse,
	);
}
/*************** Create Company End ******************/

/*************** Get All Company List Start ******************/
export function* getCompanyListDetails({ payload }: any) {
	try {
		const { databaseName, limit, searchInput } = payload;
		const key = 'GetAllCompanyListKey';
		const jsonData = {
			DatabaseName: databaseName,
			Limit: limit,
			SearchData: searchInput,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(companyGetList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getCompanyListFailure(responseData.data));
		} else {
			yield put(getCompanyListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getCompanyListFailure(error));
	}
}

export function* resetGetCompanyListResponse() {
	yield put(getCompanyListResponseChanged());
}

export function* onGetCompanyList() {
	yield takeLatest(CompanyActionTypes.GET_COMPANY_LIST_START, getCompanyListDetails);
}

export function* onGetCompanyListResponseReset() {
	yield takeLatest(
		CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_RESET,
		resetGetCompanyListResponse,
	);
}
/*************** Get All Company List End ******************/

/*************** Fetch Company Details Start ******************/
export function* fetchCompanyDetails({ payload }: any) {
	try {
		const { databaseName, companyID } = payload;
		const key = 'FetchCompanyDetailsKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(companyDetailsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchCompanyDetailsFailure(responseData.data));
		} else {
			yield put(fetchCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchCompanyDetailsFailure(error));
	}
}

export function* resetFetchCompanyDetailsResponse() {
	yield put(fetchCompanyDetailsResponseChanged());
}

export function* onFetchCompanyDetails() {
	yield takeLatest(CompanyActionTypes.FETCH_COMPANY_DETAILS_START, fetchCompanyDetails);
}

export function* onFetchCompanyDetailsResponseReset() {
	yield takeLatest(
		CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_RESET,
		resetFetchCompanyDetailsResponse,
	);
}
/*************** Fetch Company Details End ******************/

/*************** Update Company Details Start ******************/
export function* updateCompanyDetails({ payload }: any) {
	try {
		const {
			companyID,
			companyName,
			companyWebsite,
			companyAddress,
			companyPhoneNumber,
			companyEmailID,
			companyPincode,
			state,
			stateName,
			city,
			emergencyPhoneNumber,
			companyGstNumber,
			companyPayment,
			companyPanNumber,
			companyTinNumber,
			companyFax,
			companyAlternateEmailID,
			companyAlternatePhoneNumber,
			companyAlternateFax,
			companyAuthority1,
			companyAuthority2,
			companyAuthority3,
			companyModal,
			isSMSAvailed,
			isPrePaid,
			NoOfSMSAlloted,
			smsSenderName,
			isThrift,
			singleCenterGroup,
			collectionPhotoNeeded,
			individualMemberSavings,
			groupSavings,
			groupLoan,
			maxRuralIncome,
			maxUrbanIncome,
			collectionLocationNeeded,
			nachCollection,
			morotiumUpdateNeeded,
			groupAccountNeeded,
			trainingNeededForLoanApproval,
			isIndividualLoan,
			isNomineeLoanApproval,
			goldLoanAvailed,
			needJournalEntryAfterEOD,
			provisionType,
			percentageOnSellingPrice,
			sponsorBankCode,
			utilityBankCode,
			primaryAccountHolder,
			checkAadharExist,
			checkMobileNoExist,
			isMonexoNeeded,
			isOfficerAttendanceNeeded,
			isWorkFlowManagementNeeded,
			isDailyEODNeeded,
			isDueReminderSMS,
			remindBeforeNoOfDays,
			isProductConfigNeed,
			isSubAccountNeed,
			isPersonalLoanWithRangeProductNeeded,
			houseVerifyNeededNoOfDays,
			adminName,
			adminPhoneNumber,
			adminEmailID,
			adminPassword,
			adminPhoto,
			adminPaid,
			accountArr,
			infogCompanyID,
			databaseName,
			isSeperateInstance,
			isDuePaymentSMS,
			isForLeader,
			isForAllMember,
			generalCompanyID,
			PreviousSellingPrice,
			userID,
			onBoardingMember,
			companyCountry,
			loanAdvance,
			isDueRemSMSNeeded,
			instanceName,
			paymentMethodTab,
			instanceStaffID,
			financeCompanyID,
		} = payload;
		const key = 'UpdateCompanyDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			CompanyName: companyName,
			CompanyWebsite: companyWebsite,
			CompanyAddress: companyAddress,
			CompanyPhoneNumber: companyPhoneNumber,
			CompanyEmail: companyEmailID,
			CompanyPinCode: companyPincode,
			CompanyCountry: 'India',
			CompanyState: state,
			CompanyStateName: stateName,
			CompanyCity: city,
			EmergencyPhoneNumber: emergencyPhoneNumber,
			CompanyGSTIN: companyGstNumber,
			CompanyPayment: companyPayment,
			CompanyPAN: companyPanNumber,
			CompanyTIN: companyTinNumber,
			CompanyFax: companyFax,
			CompanyCreatedBy: userID,
			PreviousSellingPercentage: PreviousSellingPrice,
			CompanyAltEmail: companyAlternateEmailID,
			CompanyAltPhone: companyAlternatePhoneNumber,
			CompanyAltFax: companyAlternateFax,
			CompanyAuthority1: companyAuthority1,
			CompanyAuthority2: companyAuthority2,
			CompanyAuthority3: companyAuthority3,
			CompanyModal: companyModal,
			IsSMSAvailed: isSMSAvailed,
			IsPrepaid: isPrePaid,
			NoOfSMSAllowed: NoOfSMSAlloted,
			SMSSenderName: smsSenderName,
			IsThrift: isThrift,
			IsSingleGroupCenter: singleCenterGroup,
			IsCollectionPhotoNeeded: collectionPhotoNeeded,
			IsIndividualSavings: individualMemberSavings,
			IsGroupSaving: groupSavings,
			IsGroupLoan: groupLoan,
			MaxRuralIncome: maxRuralIncome,
			MaxUrbanIncome: maxUrbanIncome,
			IsCollectionLocationNeeded: collectionLocationNeeded,
			IsNachCollectionNeeded: nachCollection,
			IsMorotiumUpdateNeeded: morotiumUpdateNeeded,
			IsGroupAccountNeeded: groupAccountNeeded,
			IsTrainingMandatoryForLoan: trainingNeededForLoanApproval,
			IsIndividualLoanNeeded: isIndividualLoan,
			IsNomineeLoanApproval: isNomineeLoanApproval,
			IsGoldLoanAvailed: goldLoanAvailed,
			NeedJournalEntryAfterEOD: needJournalEntryAfterEOD,
			ProvisionType: provisionType,
			PercentageOnSellingPrice: percentageOnSellingPrice,
			SponsorBankCode: sponsorBankCode,
			UtilityBankCode: utilityBankCode,
			PrimaryAccountHolder: primaryAccountHolder,
			CheckAadharExist: checkAadharExist,
			CheckMobileNoExist: checkMobileNoExist,
			IsMonexoNeeded: isMonexoNeeded,
			IsOfficerAttendanceNeeded: isOfficerAttendanceNeeded,
			IsWorkFlowManagementNeeded: isWorkFlowManagementNeeded,
			IsDailyEODNeeded: isDailyEODNeeded,
			IsDueReminderSMS: isDueRemSMSNeeded,
			RemindBeforeNoOfDays: remindBeforeNoOfDays,
			IsProductConfigNeed: isProductConfigNeed,
			IsSubAccountNeed: isSubAccountNeed,
			IsPersonalLoanWithRangeProductNeeded: isPersonalLoanWithRangeProductNeeded,
			HouseVerifyNeededNoOfDays: houseVerifyNeededNoOfDays,
			AdminID: userID,
			AdminName: adminName,
			AdminPhoneNumber: adminPhoneNumber,
			AdminEmailID: adminEmailID,
			AdminPassword: adminPassword,
			AdminPhoto: adminPhoto,
			AmountPaid: adminPaid,
			AccountArr: accountArr,
			InfogID: infogCompanyID,
			InstanceName: instanceName,
			DatabaseName: databaseName,
			IsSeperateInstance: isSeperateInstance,
			IsOnBoardingMemberSMS: onBoardingMember,
			IsduePaymentSMS: isDuePaymentSMS,
			IsForLeader: isForLeader,
			IsForAllMember: isForAllMember,
			GeneralCompanyID: generalCompanyID,
			GeneralAdminID: userID,
			LoanAdvance: loanAdvance,
			PaymentMethodTab: paymentMethodTab,
			InstanceStaffID: instanceStaffID,
			FinanceID: financeCompanyID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(companyDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCompanyDetailsFailure(responseData.data));
		} else {
			yield put(updateCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCompanyDetailsFailure(error));
	}
}

export function* resetUpdateCompanyDetailsResponse() {
	yield put(updateCompanyDetailsResponseChanged());
}

export function* onUpdateCompanyDetails() {
	yield takeLatest(CompanyActionTypes.UPDATE_COMPANY_DETAILS_START, updateCompanyDetails);
}

export function* onUpdateCompanyDetailsResponseReset() {
	yield takeLatest(
		CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_RESET,
		resetUpdateCompanyDetailsResponse,
	);
}
/*************** Update Company Details End ******************/

/*************** Delete Company Details Start ******************/
export function* deleteCompanyDetails({ payload }: any) {
	try {
		const { databaseName, companyID, companyIsActive, reason } = payload;
		const key = 'DeleteCompanyDetailsKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			CompanyIsActive: companyIsActive,
			Reason: reason,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(companyDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteCompanyDetailsFailure(responseData.data));
		} else {
			yield put(deleteCompanyDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteCompanyDetailsFailure(error));
	}
}

export function* resetDeleteCompanyDetailsResponse() {
	yield put(deleteCompanyDetailsResponseChanged());
}

export function* onDeleteCompanyDetails() {
	yield takeLatest(CompanyActionTypes.DELETE_COMPANY_DETAILS_START, deleteCompanyDetails);
}

export function* onDeleteCompanyDetailsResponseReset() {
	yield takeLatest(
		CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_RESET,
		resetDeleteCompanyDetailsResponse,
	);
}
/*************** Delete Company Details End ******************/

// FINANCE COMPANY

/*************** Create Company For Finance Start ******************/
export function* companyForAdd({ payload }: any) {
	try {
		const {
			instanceName,
			companyPhoneNumber,
			companyEmailID,
			companyName,
			companyWebsite,
			companyAddress,
			state,
			city,
			companyPincode,
			whichMIS,
			country,
			newHrDB,
			newFinanceDB,
			loanAdvance,
			onBoardingMember,
			trainingNeededForLoanApproval,
			isDueReminderSMS,
			isDueRemSMSNeeded,
			isPersonalLoanWithRangeProductNeededed,
		} = payload;
		const key = 'AddCompanyKey';
		const jsonData = {
			InstanceName: instanceName,
			CompanyPhoneNumber: companyPhoneNumber,
			CompanyEmail: companyEmailID,
			CompanyName: companyName,
			CompanyWebsite: companyWebsite,
			CompanyAddress: companyAddress,
			CompanyCountry: country,
			CompanyState: state,
			CompanyCity: city,
			CompanyPinCode: companyPincode,
			WhichMIS: whichMIS,
			NewHrDB: newHrDB,
			NewFinanceDB: newFinanceDB,
			LoanAdvance: loanAdvance,
			IsOnBoardingMemberSMS: onBoardingMember,
			IsTrainingMandatoryForLoan: trainingNeededForLoanApproval,
			IsDueReminderSMS: isDueRemSMSNeeded,
			IsPersonalLoanWithRangeProductNeeded: isPersonalLoanWithRangeProductNeededed,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(createCompany, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createCompanyFailure(responseData.data));
		} else {
			yield put(createCompanySuccess(responseData.data));
		}
	} catch (error) {
		yield put(createCompanyFailure(error));
	}
}

export function* resetAddCompanyResponse() {
	yield put(createCompanyResponseChanged());
}

export function* onAddCompany() {
	yield takeLatest(CompanyActionTypes.CREATE_COMPANY_START, companyForAdd);
}

export function* onAddCompanyResponseReset() {
	yield takeLatest(CompanyActionTypes.CREATE_COMPANY_RESPONSE_RESET, resetAddCompanyResponse);
}
/*************** Create Company For Finance End ******************/

/*************** Update Company For Finance Start ******************/
export function* companyForUpdate({ payload }: any) {
	try {
		const {
			instanceName,
			companyPhoneNumber,
			companyEmailID,
			companyName,
			companyWebsite,
			companyAddress,
			state,
			city,
			infogCompanyID,
			companyPincode,
			whichMIS,
			loanAdvance,
			onBoardingMember,
			trainingNeededForLoanApproval,
			isDueReminderSMS,
			isDueRemSMSNeeded,
		} = payload;
		const key = 'UpdateCompanyKey';
		const jsonData = {
			InstanceName: instanceName,
			CompanyPhoneNumber: companyPhoneNumber,
			CompanyEmail: companyEmailID,
			CompanyName: companyName,
			CompanyWebsite: companyWebsite,
			CompanyAddress: companyAddress,
			CompanyCountry: 'India',
			CompanyState: state,
			CompanyCity: city,
			CompanyID: infogCompanyID,
			CompanyPinCode: companyPincode,
			WhichMIS: whichMIS,
			LoanAdvance: loanAdvance,
			IsOnBoardingMemberSMS: onBoardingMember,
			IsTrainingMandatoryForLoan: trainingNeededForLoanApproval,
			IsDueReminderSMS: isDueRemSMSNeeded,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateCompany, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateCompanyFailure(responseData.data));
		} else {
			yield put(updateCompanySuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateCompanyFailure(error));
	}
}

export function* resetUpdateCompanyResponse() {
	yield put(updateCompanyResponseChanged());
}

export function* onUpdateCompany() {
	yield takeLatest(CompanyActionTypes.UPDATE_COMPANY_START, companyForUpdate);
}

export function* onUpdateCompanyResponseReset() {
	yield takeLatest(CompanyActionTypes.UPDATE_COMPANY_RESPONSE_RESET, resetUpdateCompanyResponse);
}
/*************** Update Company For Finance End ******************/

/*************** Delete Company For Finance Start ******************/
export function* companyForDelete({ payload }: any) {
	try {
		const { companyID, instanceName } = payload;
		const key = 'DeleteCompanyKey';
		const jsonData = {
			InstanceName: instanceName,
			CompanyID: companyID,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(deleteCompany, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteCompanyFailure(responseData.data));
		} else {
			yield put(deleteCompanySuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteCompanyFailure(error));
	}
}

export function* resetDeleteCompanyResponse() {
	yield put(deleteCompanyResponseChanged());
}

export function* onDeleteCompany() {
	yield takeLatest(CompanyActionTypes.DELETE_COMPANY_START, companyForDelete);
}

export function* onDeleteCompanyResponseReset() {
	yield takeLatest(CompanyActionTypes.DELETE_COMPANY_RESPONSE_RESET, resetDeleteCompanyResponse);
}
/*************** Delete Company For Finance End ******************/

/** ***************** ADD INSTANCE DETAILS START *********************** */
export function* addInstanceDetails({ payload }: any) {
	try {
		const { instanceName } = payload;
		const key = 'CreateInstanceDBKey';
		const jsonData = {
			InstanceName: instanceName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(instanceDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addInstanceDetailsFailure(responseData.data));
		} else {
			yield put(addInstanceDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addInstanceDetailsFailure(error));
	}
}

export function* resetAddInstanceResponse() {
	yield put(addInstanceDetailsResponseChanged());
}

export function* onAddInstanceDetails() {
	yield takeLatest(CompanyActionTypes.ADD_INSTANCE_DETAILS_START, addInstanceDetails);
}

export function* onAddInstanceDetailsResponseReset() {
	yield takeLatest(
		CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_RESET,
		resetAddInstanceResponse,
	);
}
/** ***************** ADD INSTANCE DETAILS END *********************** */

/** ***************** ADD ALTER TABLE  DETAILS START *********************** */
export function* addAlterTableDetails({ payload }: any) {
	try {
		const key = 'AlterQueryDBKey';
		const { dataType, columName, tableName } = payload;
		const jsonData = {
			DataType: dataType,
			ColumnName: columName,
			TableName: tableName,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(AlterTableCreate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addAlterTableDetailsFailure(responseData.data));
		} else {
			yield put(addAlterTableDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addAlterTableDetailsFailure(error));
	}
}

export function* resetAddAlterTableDetailsResponse() {
	yield put(addAlterTableDetailsResponseChanged());
}

export function* onAddCashtransactionDetails() {
	yield takeLatest(CompanyActionTypes.ADD_ALTER_TABLE_START, addAlterTableDetails);
}

export function* onAddAlterTableDetailsResponseReset() {
	yield takeLatest(
		CompanyActionTypes.ADD_ALTER_TABLE_RESPONSE_RESET,
		resetAddAlterTableDetailsResponse,
	);
}
/** ***************** ADD ALTER TABLE  DETAILS END *********************** */

/** ***************** FETCH EXIST DATA START *********************** */
export function* fetchExistDataSaga({ payload }: any) {
	try {
		const key = 'VerifyDataKey';
		const { companyPhoneNumber, adminEmailID, adminPhoneNumber, companyEmailID, companyName } =
			payload;

		const jsonData = {
			CompanyPhoneNumber: companyPhoneNumber,
			CompanyEmail: companyEmailID,
			UserEmailID: adminEmailID,
			AdminPhoneNumber: adminPhoneNumber,
			CompanyName: companyName,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(fetchExistData, encodeData);

		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchExistDataFailure(responseData.data));
		} else {
			yield put(fetchExistDataSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchExistDataFailure(error));
	}
}

export function* resetFetchExistDataResponse() {
	yield put(fetchExistDataResponseChanged());
}

export function* onFetchExistData() {
	yield takeLatest(CompanyActionTypes.FETCH_EXIST_DATA_START, fetchExistDataSaga);
}

export function* onFetchExistDataResponseReset() {
	yield takeLatest(
		CompanyActionTypes.FETCH_EXIST_DATA_RESPONSE_RESET,
		resetFetchExistDataResponse,
	);
}
/** ***************** FETCH EXIST DATA END *********************** */

export function* companySaga() {
	yield all([
		call(onAddCompanyDetails),
		call(onAddCompanyDetailsResponseReset),
		call(onGetCompanyList),
		call(onGetCompanyListResponseReset),
		call(onFetchCompanyDetails),
		call(onFetchCompanyDetailsResponseReset),
		call(onUpdateCompanyDetails),
		call(onUpdateCompanyDetailsResponseReset),
		call(onDeleteCompanyDetails),
		call(onDeleteCompanyDetailsResponseReset),
		// Finance Company
		call(onAddCompany),
		call(onAddCompanyResponseReset),
		call(onUpdateCompany),
		call(onUpdateCompanyResponseReset),
		call(onDeleteCompany),
		call(onDeleteCompanyResponseReset),
		call(onAddInstanceDetailsResponseReset),
		call(onAddInstanceDetails),
		call(onAddCashtransactionDetails),
		call(onAddAlterTableDetailsResponseReset),
		call(onFetchExistData),
		call(onFetchExistDataResponseReset),
	]);
}
